const Section7 = () => {
  return (
    <section
      className='relative flex flex-col lg:flex-row items-center w-full 
  h-[480px] sm:h-[520px] md:h-[650px] lg:h-[800px] bg-orange-900 
  p-4 sm:p-6 md:p-10 lg:p-16 bg-cover bg-center'
    >
      {/* Left Side - Image */}
      <div
        className='relative z-10 
    w-full sm:w-[90%] md:w-1/2 lg:w-1/2 
    h-[280px] sm:h-[350px] md:h-[650px] lg:h-[800px] lg:right-60
    flex justify-center mx-auto'
      >
        <img
          src='./Doctor2.png'
          alt='Aisha Bello'
          className='w-full h-full object-cover rounded-lg'
        />

        {/* Testimonial Card */}
        <div
          className='absolute 
      w-[90%] sm:max-w-[320px] md:max-w-[480px] lg:max-w-[590px]
      max-h-fit
      sm:bottom-[20px] sm:right-[10px] 
      md:bottom-[40px] md:right-[-80px] 
      lg:bottom-[280px] lg:right-[-490px]'
        >
          <div
            className='relative rounded-lg p-4 md:p-6 lg:p-10 text-white shadow-lg'
            style={{
              background: 'linear-gradient(135deg, #803F11 0%, #1A0D03 100%)',
            }}
          >
            {/* Background pattern */}
            <img
              src='./yew.png'
              alt='Background pattern'
              className='absolute 
          w-[160px] sm:w-[200px] md:w-[260px] lg:w-[314px] 
          bottom-[-15px] right-[-60px] 
          object-cover opacity-70 z-[-1]'
            />

            {/* Testimonial Text */}
            <p className='text-xs sm:text-sm md:text-base font-raleway mb-1'>
              I’m absolutely loving this offline feature! As a nurse, i know how
              crucial it is to stay updated on the latest health practices. This
              platform has been a life saver - i can access lessons, watch
              videos and complete quizzes anywhere, anytime, even without
              internet. The content is engaging, easy to understand and relevant
              to my work. I’ve already recommended it to my colleagues! 5 stars
              isn’t enough - I'd give it 10 stars if i could!
            </p>

            {/* Author */}
            <div className='flex items-center mt-4'>
              <div
                className='border border-dashed border-orange-500 rounded-full flex items-center justify-center 
            w-[70px] h-[70px] sm:w-[80px] sm:h-[80px] md:w-[95px] md:h-[95px] lg:w-[108px] lg:h-[108px] p-2'
              >
                <img
                  src='./girl.png'
                  alt='Aisha Bello'
                  className='w-[60px] h-[60px] sm:w-[65px] sm:h-[65px] md:w-[80px] md:h-[80px] lg:w-[90px] lg:h-[90px] object-cover rounded-full'
                />
              </div>

              <div className='ml-4 flex flex-col items-center space-y-1'>
                <h4 className='font-medium font-raleway text-white'>
                  Aisha Bello
                </h4>
                <p className='text-sm text-gray-300 font-raleway'>Nurse</p>
              </div>
            </div>
          </div>

          {/* Comma Decoration */}
          <div
            className='absolute 
        w-[16px] sm:w-[18px] md:w-[23px] lg:w-[27px] 
        top-[10px] left-[5px] z-10'
          >
            <img
              src='./comma.png'
              alt='Quote'
              className='w-full h-full object-cover'
            />
          </div>

          {/* Dots Decoration */}
          <div
            className='absolute flex items-center space-x-2 
        right-[20px] sm:right-[40px] md:right-[70px] lg:right-[96px] 
        sm:bottom-[399px] md:bottom-[45px] lg:bottom-[59px]'
          >
            <span className='rounded-full bg-white w-[6px] h-[6px] md:w-[8px] md:h-[8px] lg:w-[10px] lg:h-[10px]' />

            <div
              className='border border-white rounded-full flex items-center justify-center 
          w-[14px] h-[14px] md:w-[17px] md:h-[17px] lg:w-[20px] lg:h-[20px]'
            >
              <span className='rounded-full bg-white w-[6px] h-[6px] md:w-[8px] md:h-[8px] lg:w-[10px] lg:h-[10px]' />
            </div>

            <span className='rounded-full bg-white w-[6px] h-[6px] md:w-[8px] md:h-[8px] lg:w-[10px] lg:h-[10px]' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section7;
